import { API_URL } from '../../app/api';

interface IFileImageByApiProps {
    className?: string,
    imgFileName?: string | null,
}

function ImageFileByApi(props: IFileImageByApiProps) {
    const { className, imgFileName } = props;

    if (!imgFileName) {
        return null;
    }

    return <img src={`${API_URL}/files/${imgFileName}`} className={className}/>
}

export default ImageFileByApi;
